var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exam",
    transform: "translate(3302 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    transform: "translate(-3302 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "examination",
    transform: "translate(-3332 5605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M213.536,112.322H173.357A5.357,5.357,0,0,1,168,106.965V45.357A5.357,5.357,0,0,1,173.357,40H205.5l13.393,12.054v54.911A5.357,5.357,0,0,1,213.536,112.322Z",
    transform: "translate(-106.571)",
    fill: "#fabe19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M392,40v6.7a5.357,5.357,0,0,0,5.357,5.357h8.036Z",
    transform: "translate(-293.071)",
    fill: "#f5871e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M90.679,40a2.679,2.679,0,0,1,2.679,2.679v2.679H88V42.679A2.679,2.679,0,0,1,90.679,40Z",
    transform: "translate(-39.964)",
    fill: "#55525b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M104,40a2.679,2.679,0,0,1,2.679,2.679v2.679H104Z",
    transform: "translate(-53.286)",
    fill: "#353744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M72,104H82.714v33.483H72Z",
    transform: "translate(-26.643 -53.286)",
    fill: "#d7e6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M104,104h5.357v33.483H104Z",
    transform: "translate(-53.286 -53.286)",
    fill: "#a5c3dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M72,304H82.714v21.429H72Z",
    transform: "translate(-26.643 -219.803)",
    fill: "#55525b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M104,304h5.357v21.429H104Z",
    transform: "translate(-53.286 -219.803)",
    fill: "#353744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M78.745,437.954,82.714,432H72l3.969,5.954a1.668,1.668,0,0,0,2.776,0Z",
    transform: "translate(-26.643 -326.374)",
    fill: "#a5c3dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M96.507,464.6l.4-.6H93.333l.4.6a1.668,1.668,0,0,0,2.776,0Z",
    transform: "translate(-44.404 -353.017)",
    fill: "#353744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M45.357,90.679V88H42.679A2.679,2.679,0,0,0,40,90.679v16a2.729,2.729,0,0,0,2.549,2.751,2.679,2.679,0,1,0,.13-5.354V90.679Z",
    transform: "translate(0 -39.964)",
    fill: "#55525b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M74.679,72h5.357a2.679,2.679,0,0,1,2.679,2.679v2.679H72V74.679A2.679,2.679,0,0,1,74.679,72Z",
    transform: "translate(-26.643 -26.643)",
    fill: "#55525b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M104,72h2.679a2.679,2.679,0,0,1,2.679,2.679v2.679H104Z",
    transform: "translate(-53.286 -26.643)",
    fill: "#353744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M238.021,88a4.693,4.693,0,0,0-4.688,4.688v7.366a1.339,1.339,0,0,0,2.679,0V96.036h4.018v4.018a1.339,1.339,0,0,0,2.679,0V92.688A4.693,4.693,0,0,0,238.021,88Zm-2.009,5.357v-.67a2.009,2.009,0,1,1,4.018,0v.67Z",
    transform: "translate(-160.967 -39.964)",
    fill: "#6478b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M196.723,56a12.723,12.723,0,1,0,12.723,12.723A12.723,12.723,0,0,0,196.723,56Zm0,22.768a10.045,10.045,0,1,1,10.045-10.045A10.045,10.045,0,0,1,196.723,78.768Z",
    transform: "translate(-119.893 -13.321)",
    fill: "#6478b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(66.191 73.674)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 26,
    height: 5,
    rx: 2.5,
    transform: "translate(-0.191 0.326)",
    fill: "#f5871e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 26,
    height: 5,
    rx: 2.5,
    transform: "translate(-0.191 13.326)",
    fill: "#f5871e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 26,
    height: 6,
    rx: 3,
    transform: "translate(-0.191 26.326)",
    fill: "#f5871e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M376.929,232.043h-.018a2.009,2.009,0,0,1-1.428-.614l-2.63-2.727a2.009,2.009,0,0,1,2.892-2.789l1.21,1.255,3.911-3.911a2.009,2.009,0,0,1,2.841,2.841l-5.357,5.357A2.009,2.009,0,0,1,376.929,232.043Z",
    transform: "translate(-276.661 -152.087)",
    fill: "#6478b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M376.929,314.713h-.018a2.009,2.009,0,0,1-1.428-.614l-2.63-2.727a2.009,2.009,0,1,1,2.893-2.789l1.21,1.256,3.911-3.911a2.009,2.009,0,0,1,2.841,2.841l-5.357,5.357A2.009,2.009,0,0,1,376.929,314.713Z",
    transform: "translate(-276.661 -220.917)",
    fill: "#6478b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M376.929,389.379h-.018a2.01,2.01,0,0,1-1.428-.614l-2.63-2.727a2.009,2.009,0,1,1,2.892-2.789l1.21,1.256,3.911-3.911a2.009,2.009,0,1,1,2.841,2.841l-5.357,5.357A2.009,2.009,0,0,1,376.929,389.379Z",
    transform: "translate(-276.66 -283.084)",
    fill: "#6478b9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/Exam.5138d6cc264ae633011d8302dedc8442.svg";
export { ForwardRef as ReactComponent };